export const DEFAULT_MESSAGE_TTL_MS = 60 * 1000;
